export default "__VITE_ASSET__7f1fd68d__"